import { getUser } from 'services/local/auth';
import type { LocalStorageFunctions, LocalProductSaved } from './types';
import type { AppropriateTextSaved } from 'pages/ECommerceCreate/types';

const PRODUCT_SAVED: string = 'product-saved';

const getLocalStorageProductSaved = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return [];
  const choice = fn.readObject<Record<string, AppropriateTextSaved[]>>(PRODUCT_SAVED);
  if (!choice?.[user.user.email]) return [];
  return choice[user.user.email];
};

const setLocalStorageProductSaved = (fn: LocalStorageFunctions) => (data: AppropriateTextSaved[]) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, AppropriateTextSaved[]>>(PRODUCT_SAVED);
  if (!choice) {
    choice = {};
  }
  choice[user.user.email] = data;
  fn.writeObject(PRODUCT_SAVED, choice);
};

const delLocalStorageProductSaved = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, AppropriateTextSaved[]>>(PRODUCT_SAVED);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(PRODUCT_SAVED, choice);
};

const productSaved = (fn: LocalStorageFunctions): LocalProductSaved => ({
  getLocalStorageProductSaved: getLocalStorageProductSaved(fn),
  setLocalStorageProductSaved: setLocalStorageProductSaved(fn),
  delLocalStorageProductSaved: delLocalStorageProductSaved(fn)
});

export default productSaved;
